module.exports = __webpack_public_path__ + "img/schwalm.203818aa.svg";